import { Injectable } from '@angular/core';
import { ClickCallbackLink, isClickCallbackLink } from '@platform-frontend/util';
import { CallbackLinkRenderer } from './callback-link-renderer';

@Injectable()
export class ClickCallbackLinkRenderer extends CallbackLinkRenderer<ClickCallbackLink> {
  supports(link: unknown): link is ClickCallbackLink {
    return isClickCallbackLink(link);
  }

  override render(link: ClickCallbackLink, targetElement: HTMLAnchorElement): void {
    if (link.id) {
      targetElement.setAttribute('id', link.id);
    }
    super.render(link, targetElement);
    targetElement.addEventListener('click', () => link.onClick());
  }
}
